import type { Tool } from '@/features/traceability/type/Tool';
import type { ToolResponse } from '@/features/traceability/api/TraceabilityResponseType';

export const parseToolResponse = (
  response: ToolResponse | Tool | null | undefined
): Tool | null => {
  if (!response) {
    return null;
  }

  const maybeResponse = response as ToolResponse;
  if (typeof maybeResponse === 'object' && 'toolContent' in maybeResponse) {
    const { toolContent } = maybeResponse;
    if (Array.isArray(toolContent)) {
      return (toolContent[0] as Tool | undefined) ?? null;
    }
    if (toolContent) {
      return toolContent as Tool;
    }
  }

  const maybeTool = response as Tool;
  if (
    typeof maybeTool === 'object' &&
    maybeTool !== null &&
    'toolId' in maybeTool &&
    Array.isArray(maybeTool.traces)
  ) {
    return maybeTool;
  }

  return null;
};
